import React, { useEffect, useRef } from 'react'

import { DrawerBody } from './__internal__/drawer-body'
import { DrawerContent } from './__internal__/drawer-content'
import { DrawerFullWidthAnchorElementButton } from './__internal__/drawer-full-width-anchor-element-button'
import { DrawerFullWidthButton } from './__internal__/drawer-full-width-button'
import { DrawerImage } from './__internal__/drawer-image'
import { DrawerTitle } from './__internal__/drawer-title'
import type { DrawerVisibility } from './drawer-visibility'

export function Drawer({
  children,
  drawerVisibility,
  onClose,
}: {
  readonly children: React.ReactNode
  readonly drawerVisibility: DrawerVisibility
  readonly onClose: () => void
}) {
  const dialogRef = useRef<HTMLDialogElement>(null)

  useEffect(
    function setDrawerVisibility() {
      const dialog = dialogRef.current

      if (drawerVisibility === 'visible' && dialog?.open === false) {
        dialog?.showModal()
        return
      }

      if (drawerVisibility === 'hidden' && dialog?.open === true) {
        dialog?.close()
        return
      }
    },
    [drawerVisibility],
  )

  useEffect(
    function setOnCloseHandler() {
      const dialog = dialogRef.current
      dialog?.addEventListener('close', onClose)
      return function cleanup() {
        dialog?.removeEventListener('close', onClose)
      }
    },
    [onClose],
  )

  return (
    <dialog
      className={
        'm-auto rounded-[20px] backdrop:bg-acorns-slate backdrop:opacity-25 shadow-lg max-md:w-full max-md:max-w-full max-md:inset-x-0 max-md:bottom-0 max-md:top-auto max-md:mx-0 max-md:my-0 max-md:rounded-t-[20px] max-md:rounded-b-none'
      }
      ref={dialogRef}
    >
      {children}
    </dialog>
  )
}

Drawer.Content = DrawerContent
Drawer.Image = DrawerImage
Drawer.Title = DrawerTitle
Drawer.Body = DrawerBody
Drawer.FullWidthButton = DrawerFullWidthButton
Drawer.FullWidthAnchorElementButton = DrawerFullWidthAnchorElementButton
